import type { ModelOrderCancellationTermsResponse } from '@layup/api-sdk';

/*
 Returns true if the first cancellation policy term charges a full (100%) cancellation fee.
*/
export const hasFullCancellationPolicy = (cancellationTerms?: ModelOrderCancellationTermsResponse): boolean =>
  cancellationTerms?.definition?.[0]?.policy?.definition?.percentage === 100;

/*
 This function calculates the cancellation fee based on the provided cancellation terms, deposit, and amount with fees.
 It does not cater for dynamic cancellation policies.
*/
export const calculateCancellationFee = (
  cancellationTerms: ModelOrderCancellationTermsResponse,
  deposit: number,
  amountWithFees: number,
): number | undefined => {
  if (
    !cancellationTerms ||
    !cancellationTerms.definition ||
    cancellationTerms.definition.length !== 1 ||
    !cancellationTerms.definition[0].policy ||
    !cancellationTerms.definition[0].policy.name
  ) {
    return undefined;
  }
  const policy = cancellationTerms.definition[0].policy;
  if (policy.name === 'Combination') {
    if (policy.definition?.deposit && policy.definition.flatFee) {
      return (deposit || 0) + policy.definition.flatFee;
    }
    if (policy.definition?.percentage && policy.definition.flatFee) {
      return amountWithFees * (policy.definition.percentage / 100) + policy.definition.flatFee;
    }
  }
  if (policy.definition?.percentage) {
    return amountWithFees * (policy.definition.percentage / 100);
  }
  if (policy.definition?.deposit) {
    return deposit;
  }
  if (policy.definition?.flatFee) {
    return policy.definition.flatFee;
  }
  return 0;
};
